var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base" },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(' Закупка "' + _vm._s(_vm.purchase.title) + '" '),
          ]),
          _c("v-card-subtitle", [_vm._v(" Настройка дозаказа ")]),
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "subtitle-2 mb-2" }, [
                _vm._v(" Дозаказа по точкам "),
              ]),
              _c(
                "v-radio-group",
                {
                  model: {
                    value: _vm.purchase.backorder_settings.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.purchase.backorder_settings, "type", $$v)
                    },
                    expression: "purchase.backorder_settings.type",
                  },
                },
                _vm._l(_vm.type_items, function (i) {
                  return _c("v-radio", {
                    key: i.value,
                    attrs: { label: i.text, value: i.value },
                  })
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "mt-2",
                  style: {
                    color:
                      _vm.purchase.backorder_settings.type === "W"
                        ? "lightgrey"
                        : "grey",
                  },
                },
                [
                  _vm._v(" Примеры (Садовод):"),
                  _c("br"),
                  _vm._v(" Все места Линии 22 = "),
                  _c("strong", [_vm._v("22-*")]),
                  _c("br"),
                  _vm._v(" Все места Старого ТЦ, 1-го этажа, линии Б = "),
                  _c("strong", [_vm._v("1-Б-*")]),
                  _c("br"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "900",
                        "font-size": "2rem",
                        position: "relative",
                        top: "11px",
                      },
                    },
                    [_vm._v("*")]
                  ),
                  _vm._v(" - равносильно любому символу и кол-ву символов "),
                ]
              ),
              _c("v-select", {
                staticClass: "mt-3",
                attrs: {
                  "hide-details": "",
                  dense: "",
                  outlined: "",
                  label: "Условие",
                  disabled: _vm.purchase.backorder_settings.type === "W",
                  items: _vm.condition_items,
                },
                model: {
                  value: _vm.purchase.backorder_settings.condition,
                  callback: function ($$v) {
                    _vm.$set(_vm.purchase.backorder_settings, "condition", $$v)
                  },
                  expression: "purchase.backorder_settings.condition",
                },
              }),
              _c("v-combobox", {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  disabled: _vm.purchase.backorder_settings.type === "W",
                  "menu-props": {
                    closeOnClick: false,
                    closeOnContentClick: true,
                    disableKeys: true,
                    openOnClick: false,
                    maxHeight: 179,
                  },
                  label: "Укажите места",
                  chips: "",
                  "deletable-chips": "",
                  multiple: "",
                },
                model: {
                  value: _vm.purchase.backorder_settings.places,
                  callback: function ($$v) {
                    _vm.$set(_vm.purchase.backorder_settings, "places", $$v)
                  },
                  expression: "purchase.backorder_settings.places",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1 pt-2 text-right",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-h",
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.base.hide()
                                },
                              },
                            },
                            [_vm._v(" Готово ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }